<template>
	<div class="msg-analysis-position" :class="{'msg-analysis-position-me' : msg.is_me == 1}" @click="clickMsg">
		<div class="msg-analysis-position-titile">{{pTitle}}</div>
		<div class="msg-analysis-position-desc">{{pDesc}}</div>
		<div class="msg-analysis-position-map">
			<img :src="pUrl" alt="">
		</div>
	</div>
</template>

<script>
	import Emoji from '../../util/emoji.js'
	
	export default{
		name: 'MsgAnalysisPosition',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				pTitle: '',
				pDesc: '',
				pUrl : '',
				lat: '',
				lng: ''
			}
		},
		methods:{
			// 格式化消息
			formatMsg(){
				if (this.msg.content == undefined || this.msg.content == ''){
				    return;
				}
				let url = 'https://apis.map.qq.com/ws/staticmap/v2/?center=latP,lngP&zoom=18&size=600*300&maptype=roadmap&markers=size:large|color:0xFFCCFF|label:k|latP,lngP&key=CKDBZ-OCAC3-OJ23B-3RA47-S4TG3-E6BGR'
				let content = JSON.parse(this.msg.content)
				let lat = content.lat
				let lng = content.lng
				url = url.replace(/latP/g,lat)
				url = url.replace(/lngP/g,lng)
				this.pTitle = content.title
				this.pDesc = content.address
				this.pUrl = url
				this.lat = lat
				this.lng = lng
			},
			
			clickMsg(){
				let url = 'https://map.qq.com/?type=marker&isopeninfowin=1&markertype=1&pointx=lngP&pointy=latP&name=nameP&addr=addrP&ref=pcmap'
				url = url.replace(/latP/g,this.lat)
				url = url.replace(/lngP/g,this.lng)
				url = url.replace(/nameP/g,this.pTitle)
				url = url.replace(/addrP/g,this.pDesc)
				window.open(url,'_blank')
			}
		},
		
		created() {
			this.formatMsg()
		}
	}
</script>

<style>
	.msg-analysis-position{
		font-size: 13px;
		line-height: 20px;
		background-color: #EEEEEE;
		padding: 8px 0 0 0;
		border-radius: 2px;
		position: relative;
		cursor: pointer;
	}
	.msg-analysis-position::before{
		content: '';
		display: block;
		background-color: #EEEEEE;
		width: 12px;
		height: 12px;
		position: absolute;
		top: 8px;
		left: -6px;
		transform: rotateZ(45deg);
	}
	.msg-analysis-position-me{
		text-align: left;
	}
	.msg-analysis-position-me::before{
		right: -6px;
		left: unset;
	}
	.msg-analysis-position-titile{
		font-size: 14px;
		font-weight: bold;
		width: 220px;
		height: 20px;
		line-height: 20px;
		overflow: hidden;
		padding: 0 8px;
		box-sizing: border-box;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.msg-analysis-position-desc{
		font-size: 12px;
		width: 220px;
		height: 16px;
		line-height: 16px;
		overflow: hidden;
		color: #999999;
		padding: 0 8px 8px 8px;
		box-sizing: border-box;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.msg-analysis-position-map{
		width: 220px;
	}
	.msg-analysis-position-map img{
		width: 100%;
		height: auto;
	}
</style>
